import { z } from "zod";

import {
  PluginFindReplaceType,
  PluginTestGroupType,
} from "../../schemas/plugin/config/experiments";
import {
  CreateTestShippingSchema,
  TestShippingSchema,
  TestShippingType,
} from "../../schemas/test-shipping";
import { OnsiteEditDtoSchema } from "../onsite-edits";
import { RedirectDtoSchema } from "../redirects";
import {
  ShippingRateGroupDto,
  ShippingRateGroupDtoSchema,
} from "../shipping-rate-groups";
import { RateType, ShippingRateDtoSchema } from "../shipping-rates";
import { PriceChangeUnitList } from "../variations";

import { CampaignLikeObject, CampaignWithIdSchema } from "./campaigns";
import { ShippingRateGroupDtoSchema_2023_08_20 } from "./shipping-rate-group";

// export const PriceDirectionList = ["increase", "decrease"] as const;
// export type PriceDirection = (typeof PriceDirectionList)[number];

// export const GroupStateRoundedSidesList = [
//   "both",
//   "left",
//   "right",
//   "",
// ] as const;
// export type GroupStateRoundedSides =
//   (typeof GroupStateRoundedSidesList)[number];

// export const PriceChanceRoundingList = [
//   "none",
//   "custom",
//   "up",
//   "down",
// ] as const;
// export type PriceChangeRounding = (typeof PriceChanceRoundingList)[number];

export const TestGroupStateValuesList = [
  "isControl",
  "label",
  "name",
  "priceChange",
  "priceChangeUnit",
  "priceDirection",
  "isFreeShipping",
  "flatFee",
  "threshold",
  "bannerConfig",
  "currency",
  "freeShippingText",
  "paidShippingText",
  "enabled",
] as const;

export type TestGroupStateValuesType =
  (typeof TestGroupStateValuesList)[number];

export const TestGroupShippingGroupRateSchema = z.object({
  id: z.string().uuid(),
  shippingRateGroups: ShippingRateDtoSchema.array().default([]),
});
export type TestGroupShippingGroupRateType = z.infer<
  typeof TestGroupShippingGroupRateSchema
>;

export const RequiredTestGroupSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  percentage: z.number(),
  isControl: z.boolean().default(false),
  testCampaignId: z.string().uuid().nullish(),
  order: z.number().int(),
  isChosenWinner: z.boolean().default(false).nullish(),
  isImpactWinner: z.boolean().default(false).nullish(),
});
export type RequiredTestGroupType = z.infer<typeof RequiredTestGroupSchema>;

export const TestGroupSchema = RequiredTestGroupSchema.extend({
  // Must be nullish
  testShipping: TestShippingSchema.nullish(),
  testCampaign: CampaignWithIdSchema.nullish(),
  findReplaces: z.optional(OnsiteEditDtoSchema.array()),
  priceChangeUnit: z.enum(PriceChangeUnitList).nullish(),
  priceChange: z.union([z.string(), z.number()]).nullish(),
  shippingRateGroups: z.optional(
    ShippingRateGroupDtoSchema_2023_08_20.array().default([])
  ),
  redirects: RedirectDtoSchema.array().nullish(),
  customCss: z.string().nullish(),
  customJs: z.string().nullish(),
});

type _TestGroupType = z.infer<typeof TestGroupSchema>;
export type TestGroupDto = RequiredTestGroupType & _TestGroupType;

export const TestGroupWithTestShippingSchema = TestGroupSchema.extend({
  testShipping: TestShippingSchema,
});
export type TestGroupWithTestShippingType = z.infer<
  typeof TestGroupWithTestShippingSchema
>;

export const TestGroupDtoSchema = TestGroupSchema.extend({
  testCampaign: CampaignWithIdSchema.nullish(),
  testShipping: TestShippingSchema.nullish(),
});

export const CreateTestGroupDtoSchema = TestGroupSchema.extend({
  testCampaign: CampaignWithIdSchema.nullish(),
  testShipping: CreateTestShippingSchema.nullish(),
  id: z.string().uuid(),
});

export interface TestGroupLikeObject {
  id: string;
  name: string;
  shortId: string;
  percentage: number;
  isControl: boolean;
  order: number;
  getShippingRateAmount: (type: RateType) => number | undefined;
  testShipping: TestShippingType | undefined;
  isExcluded: boolean | undefined;
  findReplaces: PluginFindReplaceType[] | undefined;
  shippingRateGroups: ShippingRateGroupDto[] | undefined;
  testCampaign: CampaignLikeObject | undefined;
  customCss?: string | null;
  customJs?: string | null;
  toModel: () => PluginTestGroupType;
  toTrackModel: () => PluginTestGroupType;
}
